export default __webpack_public_path__ + "static/media/client47.17a4a639.png";